module.exports = __webpack_public_path__ + "media/images/icon/courses-a7d156a7f264a37b692112889f59af93.svg";